module.exports = {
    title: 'MallPraise',
    description: 'MallPraise',
    themeColor: '#409eff',
}
